export default "__VITE_ASSET__2764c421__"